import { useEffect, useRef } from 'react';

// This component pulls in external content from the DOM and renders it within a React component.
let InnerContent = ({ id }) => {
  const externalContentRef = useRef(null);

  useEffect(() => {
    const externalContent = document.getElementById(id);
    if (externalContent && externalContentRef.current) {
      externalContentRef.current.innerHTML = externalContent.innerHTML;
      externalContent.parentNode.removeChild(externalContent); // Remove external content from the DOM
    }
  }, []);

  return (
    <>
      <div id={`${id}-react`} ref={externalContentRef}></div>
    </>
  );
};

export default InnerContent;
